global.bookedby.helpers.Time = require('../../../../lib/time');
global.bookedby.helpers.Duration = require('../../../../lib/duration');
const validation = require('../../../../lib/validation/password');
global.bookedby.helpers.passwordValidate = validation.passwordValidate;
global.bookedby.helpers.confirmPasswordValidate = validation.confirmPasswordValidate;
global.bookedby.helpers.passwordRequiredValidation = validation.passwordRequiredValidation;


global.bookedby = global.bookedby || {};
global.bookedby.helpers = global.bookedby.helpers || {};
var moment = bookedby.deps != null ? bookedby.deps.moment : global.moment;
var $ = bookedby.deps != null ? bookedby.deps.$ : global.$;
var _ = bookedby.deps != null ? bookedby.deps._ : global._;
var Leaflet = require('./map-service');


//TODO:: remove this eventually
global.notYetAlert = function() {
  //alert('This feature will be activated once bookedby is integrated with aveda.com');
  return false;
};

global.bookedby.helpers.star = function(src) {
  return "*" + src + "*";
};

global.bookedby.helpers.storePhoto = function(store, imageType) {
  if (store != null && store.photoId != null) {
    return '/uploads/stores/' + store.photoId + '/' + imageType + '.jpg';
  }

  switch (imageType) {
    case 'large':
      return '/assets/images/store-default-large.jpg';
    case 'small':
      return '/assets/images/store-default-small.jpg';
    case 'thumb':
      return '/assets/images/store-default-thumb.jpg';
    default:
      return '/assets/images/store-default-large.jpg';
  }
};

global.bookedby.helpers.storePhotoById = function(photoId, imageType) {
  if (photoId != null) {
    return '/uploads/stores/' + photoId + '/' + imageType + '.jpg';
  }

  switch (imageType) {
    case 'large':
      return '/assets/images/store-default-large.jpg';
    case 'small':
      return '/assets/images/store-default-small.jpg';
    case 'thumb':
      return '/assets/images/store-default-thumb.jpg';
    default:
      return '/assets/images/store-default-large.jpg';
  }
};

global.bookedby.helpers.employeeHasBio = function(employee) {
  return employee.bio == "" ? false : true;
};

global.bookedby.helpers.employeePhoto = function(employee, imageType, baseUrl) {

  if (baseUrl == null) {
    baseUrl = '';
  } else {
    if (baseUrl.charAt(baseUrl.length-1) == '/') {
      baseUrl = baseUrl.substring(0, baseUrl.length-1);
    }
  }

  if (employee != null && employee.photoId != null) {
    return baseUrl + '/uploads/employees/' + employee.photoId + '/' + imageType + '.jpg';
  }

  switch (imageType) {
    case 'large':
      return baseUrl + '/assets/images/employee-default-large.jpg';
    case 'small':
      return baseUrl + '/assets/images/employee-default-small.jpg';
    case 'thumb':
      return baseUrl + '/assets/images/employee-default-thumb.jpg';
    default:
      return baseUrl + '/assets/images/employee-default-large.jpg';
  }
};

global.bookedby.helpers.reviewPhoto = function(review, imageType, baseUrl) {

  if (baseUrl == null) {
    baseUrl = '';
  } else {
    if (baseUrl.charAt(baseUrl.length-1) == '/') {
      baseUrl = baseUrl.substring(0, baseUrl.length-1);
    }
  }

  if (review != null && review.photoId != null) {
    return baseUrl + '/uploads/reviews/' + review.photoId + '/' + imageType + '.jpg';
  }

  switch (imageType) {
    case 'large':
      return baseUrl + '/assets/images/client-review-default.png';
    case 'small':
      return baseUrl + '/assets/images/client-review-default.png';
    case 'thumb':
      return baseUrl + '/assets/images/client-review-default.png';
    default:
      return baseUrl + '/assets/images/client-review-default.png';
  }
};

global.bookedby.helpers.photo = function(photoId, photoOf , imageType, baseUrl) {

  if (baseUrl == null) {
    baseUrl = '';
  } else {
    if (baseUrl.charAt(baseUrl.length-1) == '/') {
      baseUrl = baseUrl.substring(0, baseUrl.length-1);
    }
  }

  if (photoId != null) {
    return baseUrl + '/uploads/' + photoOf + '/' + photoId + '/' + imageType + '.jpg';
  }

  switch (imageType) {
    case 'large':
      return baseUrl + '/assets/images/employee-default-large.jpg';
    case 'small':
      return baseUrl + '/assets/images/employee-default-small.jpg';
    case 'thumb':
      return baseUrl + '/assets/images/employee-default-thumb.jpg';
    default:
      return baseUrl + '/assets/images/employee-default-large.jpg';
  }
};

global.bookedby.helpers.formatCurrency = function(value) {

  //TODO:: improve
  return '$' + parseFloat(value).toFixed(0);
};

global.bookedby.helpers.dateFormat = function(date, formatString) {
  formatString = formatString || 'LL';
  return moment(date).format(formatString);
};

global.bookedby.helpers.timeFormat = function(time) {
  return moment.utc(time * 1000).format('LT');
};

global.bookedby.helpers.timeFormatMarker = function(time) {
  var formattedTime = moment.utc(time * 1000).format('h:mm a');
  return formattedTime.replace(' ', '').slice(0, -1);
};

global.bookedby.helpers.secondsToMinutesText = function(seconds) {
  return (seconds / 60)+' minutes';
};

global.bookedby.helpers.timestampAsTimeFormat = function(time) {
  return moment(time).format('LT');
};

global.bookedby.helpers.directionsHref = function(store) {
  var params = $.param({ daddr: store.address1 + ' ' + store.address2 });
  return "https://maps.google.com?" + params;
};

/**
 * Returns phone number in the format (123) 123-1234 or 123123123 if the number is not 10 digits
 * @param {int|string} number
 * @returns {*}
 */
global.bookedby.helpers.phoneFormat = function(number) {
  if (number) {
    var numSavedFormat = number.match(/^(\+1[\d]{10})$/);
    var num = (""+number).replace(/\+1/g, '').replace(/\D/g, '');
    if (!numSavedFormat && num.length < 10) {
      return num;
    }
    else {
      var formattedNum = num.match(/^(\d{3})(\d{3})(\d{4})$/);
      return (!formattedNum) ? (number || '') : "(" + formattedNum[1] + ") " + formattedNum[2] + "-" + formattedNum[3];
    }
  }
};

/**
 * Receives a string of a phone number without prefix and returns the number in the format +11231231234
 * @param {string} stringNumber
 * @returns {string}
 */
global.bookedby.helpers.phoneInternalFormat = function(stringNumber) {
  if (stringNumber) {
    stringNumber = (stringNumber+"").replace(/\+1/g, '');
    return '+1' + stringNumber.replace(/\D/g, '');
  } else {
    return '+1';
  }
};

global.bookedby.helpers.dateFormatFocus = function(date, formatIn, formatOut, onkeyup, validateBoth) {
  if (date) {
    if (moment(date, formatIn, true).isValid()) {
      return moment(date, formatIn).format(formatOut);
    } else {
      if (validateBoth && moment(date, formatOut, true).isValid()) {
        return moment(date, formatOut).format(formatOut);
      }
      if (onkeyup) {
        return date;
      } else {
        return null;
      }
    }
  }
};

global.bookedby.helpers.birthdateFormat = function(birthDate) {
  if (birthDate) {
    if (birthDate.length != 10) {
      return birthDate;
    }

    if (!moment(birthDate, 'MM-DD-YYYY', true).isValid()) {
      return birthDate;
    } else {
      return global.bookedby.helpers.dateFormatFocus(birthDate, 'MM-DD-YYYY', 'MM-DD-YYYY', true, false);
    }
  } else {
    return null;
  }
};

global.bookedby.helpers.birthdateInternalFormat = function(birthDate) {
  var dateFormats = ["MMDDYYYY", "MM-DD-YYYY"];
  var dateFormat = "";

  if (birthDate) {
    for (var i = 0 ; i < dateFormats.length ; i++) {
      if (moment(birthDate, dateFormats[i], true).isValid()) {
        dateFormat = dateFormats[i];
        break;
      }
    }

    if (dateFormat == "") {
      return birthDate;
    }

    return moment(birthDate, dateFormat).format('MM-DD-YYYY');
  } else {
    return null;
  }
};

global.bookedby.helpers.priceRange = function(range) {
  if (range[0] == range[1]) {
    return global.bookedby.helpers.formatCurrency(range[0]);
  } else {
    return global.bookedby.helpers.formatCurrency(range[0]) + ' - ' +
      global.bookedby.helpers.formatCurrency(range[1]);
  }
};

global.bookedby.helpers.durationRange = function(range) {

  if (range[0] == range[1]) {
    return range[0]/60 + ' min.';
  } else {
    return range[0]/60 + ' - ' + range[1]/60 + ' min.';
  }
};

global.bookedby.helpers.durationRangeFull = function(range, type) {
  type = type || 'partialTime';

  if (range[0] == range[1]) {
    return global.bookedby.helpers.timeToDuration(range[1])[type];
  } else {
    return global.bookedby.helpers.timeToDuration(range[0])[type] + ' - ' + global.bookedby.helpers.timeToDuration(range[1])[type];
  }
};

global.bookedby.helpers.htmlAttributes = function(attributes, exclusions) {
  var output = "";
  if (exclusions != null) {
    attributes = _.omit(attributes, exclusions);
  }
  _.each(attributes, function(value, key) {
    if (key === 'classes') {
      key = 'class';
    }
    if (value === true) {
      output += key + " ";
    } else {
      output += key + "=\"" + value + "\" ";
    }
  });
  return output;
};

global.bookedby.helpers.partial = function(partialName, partialData) {
  return bookedby.templates[partialName](partialData, null, bookedby.helpers);
};

global.bookedby.helpers.genderFormat = function(gender) {
  return gender == 'M' ? 'Male' : (gender == 'F' ? 'Female' : 'Not specified');
};

global.bookedby.helpers.timeToDuration = function(time) {
  if (!time) {
    return { hours: 0, minutes: 0, fullTime: '0 minute(s)', partialTime: '0 min.', concatTime: '00:00', concatTimeText: '0 min.', totalMinutes: 0, totalMinutesText: '0 minutes' };
  }

  var hoursVal = Math.floor(time / 3600) % 12;
  var minuteValue = Math.floor((time / 60) % 60);
  var minuteValueFull = minuteValue;
  if (minuteValue < 10) {
    minuteValue = '0' + minuteValue;
  }

  var fullTime = "";
  if (hoursVal > 0) {
    fullTime = ( minuteValueFull > 0 ) ? hoursVal + ' hour(s) and ' : hoursVal + ' hour(s)';
  }

  var partialTime = fullTime;

  if (minuteValueFull > 0) {
    fullTime += Math.floor(minuteValueFull) + ' minute(s)';
    partialTime += Math.floor(minuteValueFull) + ' min.';
  }

  return {
    hours: hoursVal,
    minutes: minuteValueFull,
    fullTime: fullTime,
    partialTime: partialTime,
    concatTime: hoursVal + ':' + minuteValue,
    concatTimeText: hoursVal > 0 ? hoursVal + 'h' + minuteValue + 'm' : minuteValueFull > 1 ? minuteValueFull + ' mins.' : minuteValue + ' min.',
    totalMinutes: time/60,
    totalMinutesText: time/60 + ' minutes'
  };
};

global.bookedby.helpers.textTruncate = function(text, limit) {
  if (!text) {
    return text;
  }

  var isTooLong = text.length > limit;

  if (!isTooLong) {
    return text;
  }

  return text.substr(0, limit) + '...';
};

global.bookedby.helpers.secondsToMinutesRoundable = function(seconds, precision) {
  if (_.isNaN(seconds)) {
    return 0;
  }

  if (!precision) {
    return Math.round((seconds / 60));
  }

  if (precision == 0) {
    return Math.round((seconds / 60));
  }

  return Math.round(Math.round((seconds / 60)) / precision) * precision;
};

global.bookedby.helpers.locationAutocomplete = function(term, response) {

  //NOTE:: canada gets shorter valid autocomplete length due to 3-digit postal codes being meaningful
  if (term.length >= 5 || (bookedby.staticData.storeGroupSettings.countryCode == 'CA' && term.length >= 3)) {

    var geocoder = Leaflet.mapbox.geocoder('mapbox.places');

    geocoder.query({
      query: term,
      country: bookedby.staticData.storeGroupSettings.countryCode || 'US'
    }, function(error, data) {
      if (!error && data && data.results && !_.isEmpty(data.results.features)) {
        response(_.map(data.results.features, function(item) {
          return {
            label: item.place_name,
            value: item.center.join(';')
          }
        }))
      } else {
        response( [] )
      }
    });

  } else {
    response([]);
  }
};


function gaEventSender(event_name, parameters) {
  if(!window.bookedby.staticData.gaIsActive)  return;

  gtag('event', event_name, parameters);
}

global.bookedby.helpers.pinClickEvent = function(storeName) {
  gaEventSender('pin_click', {
    'event_category': 'Map Page',
    'event_action': 'Pin Click',
    'event_label': storeName
  });
};

global.bookedby.helpers.locationChosenEvent = function(location) {
  gaEventSender('location_pick', {
    'event_category': 'Map Page',
    'event_action': 'Location Select',
    'event_label': location
  });
};

global.bookedby.helpers.addGuestEvent = function(guestCount) {
  gaEventSender('add_guest', {
    'event_category': 'Map Page',
    'event_action': 'Add Guest',
    'event_label': guestCount
  });
};

global.bookedby.helpers.checkInEvent = function(action, storeShortName) {
  switch(action) {
    case 'login': gaEventSender('add_guest', {
                    'event_category': 'Map Page',
                    'event_action': 'Check In Action',
                    'event_label': 'after login'
                  }); break;
    case 'register': gaEventSender('add_guest', {
                    'event_category': 'Map Page',
                    'event_action': 'Check In Action',
                    'event_label': 'after register'
                  }); break;
    case 'checkin': gaEventSender('checkIn_action', {
                    'event_category': 'Check In',
                    'event_action': 'Checked In',
                    'event_label': storeShortName
                  }); break;
    default: gaEventSender('add_guest', {
               'event_category': 'Map Page',
               'event_action': 'Check In Action',
             }); break;
  }
};

/*global.bookedby.helpers.registerAndCheckinEvent = function() {
  gaEventSender('reg_checkin', {
    'event_category': 'Map Page',
    'event_action': 'Register & Checkin'
  });
};*/

global.bookedby.helpers.checkConfirmCodeEvent = function() {
  gaEventSender('register', {
    'event_category': 'Register Page',
    'event_action': 'Check Confirmation Code'
  });
};

global.bookedby.helpers.registerEvent = function() {
  gaEventSender('register', {
    'event_category': 'Register Page',
    'event_action': 'Register Button'
  });
};

global.bookedby.helpers.sendConfirmationAgainEvent = function() {
  gaEventSender('send_again', {
    'event_category': 'Register Page',
    'event_action': 'Send Confirmation Code Again'
  });
};

global.bookedby.helpers.loginEvent = function() {
  gaEventSender('login', {
    'event_category': 'Login Page',
    'event_action': 'Log Me In'
  });
};

global.bookedby.helpers.cancelCheckInEvent = function() {
  gaEventSender('cancel_checkin', {
    'event_category': 'Waiting List Page',
    'event_action': 'Cancel Checkin Action'
  });
};

global.bookedby.helpers.confirmCancelCheckInEvent = function() {
  gaEventSender('cancel_checkin', {
    'event_category': 'Waiting List Page',
    'event_action': 'Confirm Cancel Checkin Action'
  });
};

global.bookedby.helpers.confirmLogoutEvent = function(accountPage) {
  gaEventSender('sign_out', {
    'event_category': accountPage ? 'Account Page' : 'Map Page',
    'event_action': accountPage ? 'Confirm Logout' : 'Confirm Sign Out'
  });
};

//TODO:: this is copy-pasta from lib/time.js as we don't seem to have a good way right now of sharing helpers between back-end and front-end
//This function will return a new moment, setting the time-of-day based on the time that was passed in seconds (14:24:39 == (14*60*60)+(24*60)+39 seconds)
//This implementation is correct - it gives you the exact time-of-day that you request even during DST transitions
global.bookedby.helpers.getNewMomentWithTimeOfDayBySecond = function(dateMoment, seconds) {
  return dateMoment.clone().set({
    hour: Math.floor(seconds / (60*60)),
    minute: Math.floor((seconds % (60 * 60)) / 60),
    second: seconds % 60,
    millisecond: 0
  });
};

module.exports = {};
